<template>
  <div class="contract-detail h-[calc(100vh-180px)]">
    <div class="title">
      合同详情
    </div>
    <el-scrollbar ref="scrollbarRef" class="h-[calc(100%-84px)] mt-[16px]">
      <div v-if="route.query.contractType == '1'" v-loading="loading">
        <div class="base-card-info c-auto">
          <div class="info-card-title flex items-center">
            基础信息
          </div>
          <div class="base-info-list">
            <div class="left-list gap-y-[14px]">
              <div class="item">
                <div class="label">
                  合同信息
                </div>
                <div class="value">
                  {{ freeDetailInfo.contractSubject }} 
                  <el-link type="primary" :underline="false" class="ml-2" @click="toPreview">
                    查看合同
                  </el-link>
                </div>
              </div>
              <div class="item">
                <div class="label">
                  签收截止日期
                </div>
                <div class="value">
                  {{ freeDetailInfo.endTime }}
                </div>
              </div>
            </div>
            <div class="right-list mt-[35px]">
              <div class="item">
                <div class="label">
                  合同到期日期
                </div>
                <div class="value">
                  {{ freeDetailInfo.expireTime }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-for="(info, index) in freeDetailInfo.actorVoList" :key="info.id" class="base-card-info c-auto">
          <div class="info-card-title flex items-center">
            签署方{{ index+1 }}（{{ actorTypeConfig[info.actorType] }}-{{ platformConfig[info.platform] }}）
          </div>
          <div class="base-info-list">
            <div class="left-list gap-y-[14px]">
              <div class="item">
                <div class="label">
                  {{ info.actorType == EActorType.CORP? '企业名称': '姓名' }}
                </div>
                <div class="value">
                  {{ info.actorName }}
                </div>
              </div>
              <template v-for="(item,index1) in info.contractFieldList">
                <div v-if="index1%2==0" :key="item.field" class="item">
                  <div class="label">
                    {{ item.field }}
                  </div>
                  <div class="value">
                    {{ item.fieldValue }}
                  </div>
                </div>
              </template>
            </div>
            <div class="right-list">
              <div class="item">
                <div class="label">
                  签署要求
                </div>
                <div class="value">
                  {{ autoSignConfig[info.autoSign] }}
                </div>
              </div>
              <template v-for="(item,index1) in info.contractFieldList">
                <div v-if="index1%2==1" :key="item.field" class="item">
                  <div class="label">
                    {{ item.field }}
                  </div>
                  <div class="value">
                    {{ item.fieldValue }}
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div v-if="freeDetailInfo?.customFieldList?.length>0" class="base-card-info c-auto">
          <div class="info-card-title flex items-center">
            合同自定义字段
          </div>
          <div class="base-info-list">
            <div class="left-list gap-y-[14px]">
              <template v-for="(item,index) in freeDetailInfo.customFieldList">
                <div v-if="index%2==0" :key="item.field" class="item">
                  <div class="label">
                    {{ item.field }}
                  </div>
                  <div class="value">
                    {{ item.fieldValue }}
                  </div>
                </div>
              </template>
            </div>
            <div class="right-list">
              <template v-for="(item,index) in freeDetailInfo.customFieldList">
                <div v-if="index%2==1" :key="item.field" class="item">
                  <div class="label">
                    {{ item.field }}
                  </div>
                  <div class="value">
                    {{ item.fieldValue }}
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div v-if="route.query.contractType == '2'" v-loading="loading">
        <div class="base-card-info c-auto">
          <div class="info-card-title flex items-center">
            基础信息
          </div>
          <div class="base-info-list">
            <div class="left-list gap-y-[14px]">
              <div class="item">
                <div class="label">
                  合同信息
                </div>
                <div class="value flex items-center justify-start">
                  <svg-icon icon="ph:file-text" class="!w-[18px] mr-2" /> 
                  <el-link type="primary" :underline="false" @click="toDownload">
                    {{ offlineDetailInfo.contractSubject }} 
                    <svg-icon icon="tabler:arrow-bar-to-down" class="ml-6 !w-[18px]" />
                  </el-link>
                </div>
              </div>
              <div class="item">
                <div class="label">
                  合同主题
                </div>
                <div class="value">
                  {{ offlineDetailInfo.contractSubject }}
                </div>
              </div>
            </div>
            <div class="right-list mt-[35px]">
              <div class="item">
                <div class="label">
                  合同到期日期
                </div>
                <div class="value">
                  {{ offlineDetailInfo.expireTime }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-for="(info, index) in offlineDetailInfo.actorVoList" :key="info.id" class="base-card-info c-auto">
          <div class="info-card-title flex items-center">
            签署方{{ index+1 }}
          </div>
          <div class="base-info-list">
            <div class="left-list gap-y-[14px]">
              <div class="item">
                <div class="label">
                  端口
                </div>
                <div class="value">
                  {{ info.platformStr }}
                </div>
              </div>
            </div>
            <div class="right-list">
              <div class="item">
                <div class="label">
                  企业
                </div>
                <div class="value">
                  {{ info.actorName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="base-card-info c-auto mt-[16px]">
        <div class="info-card-title flex items-center">
          备注信息
        </div>
        <div class="base-info-list">
          <div class="color-[#344767] w-[1002px] break-all">
            {{ freeDetailInfo?.remark || offlineDetailInfo?.remark }}
          </div>
        </div>
      </div>
    </el-scrollbar>
    <div class="flex justify-start mt-[16px]">
      <el-button @click="closeAndBack">
        返回
      </el-button>
    </div>
  </div>
</template>

<script setup lang='ts'>
import { SvgIcon } from '@vue3/components';
import { queryContractCreateDetail, queryContractCreatePreview, useTabsStore, queryContractCreateDownload } from '../../../..';
import { useRoute } from 'vue-router';
import { ref } from 'vue';
import { ElMessage, ElScrollbar } from 'element-plus';
import { IContractOfflineDetailVO, IContractFreeDetailVO, EActorType, actorTypeConfig, platformConfig, autoSignConfig } from '../../../../types/contracts/contracts';

defineOptions({ name: 'InitiateContract' });

const { closeAndBack } = useTabsStore();

const route = useRoute();

const freeDetailInfo = ref<IContractFreeDetailVO>({} as IContractFreeDetailVO);
const offlineDetailInfo = ref<IContractOfflineDetailVO>({} as IContractOfflineDetailVO);
const loading = ref(false);
const scrollbarRef = ref<InstanceType<typeof ElScrollbar>>();

async function toPreview() {
  try {
    const res = await queryContractCreatePreview(Number(freeDetailInfo.value.contractId));

    window.open(res);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function toDownload() {
  try {
    const url = await queryContractCreateDownload({
      page: 1,
      size: 10,
      ids: [offlineDetailInfo.value.id],
    });

    window.open(url);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function fetchData() {
  loading.value = true;
  try {
    const { freeDetail, offlineDetail } = await queryContractCreateDetail({
      contractType: Number(route.query.contractType),
      contractId: String(route.query.contractId),
    });

    freeDetailInfo.value = freeDetail;
    offlineDetailInfo.value = offlineDetail;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
  loading.value = false;
}

fetchData();

</script>

<style lang="scss" scoped>
.contract-detail {
  .title {
    @apply pl-[24px] text-[20px] font-[600] text-[#344767];
  }
}

.base-info-list .item .label{
  width: 84px;
}
</style>
